import React, { useState, useEffect } from 'react';
import { linkStrategyToDescription } from './services/strategyService';

const StrategyHighlightsTable = ({ strategyHighlights, sdCode }) => {
  // State for controlling modal visibility and form data
  const [showModal, setShowModal] = useState(false);  // To control modal visibility
  const [strategyCode, setStrategyCode] = useState('');
  const [strategyDescriptionCode, setStrategyDescriptionCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [strategyDescriptions, setStrategyDescriptions] = useState([]);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
    const token = window.sessionStorage.getItem("jwtToken");

  // Sync strategyCode with the sdCode prop if sdCode changes
  useEffect(() => {
    if (sdCode) {
      setStrategyCode(sdCode);
    }
  }, [sdCode]);

  // Fetch strategy descriptions on component mount
  useEffect(() => {
    const fetchStrategyDescriptions = async () => {
      try {
        const response = await fetch(`${BASE_URL}/getStrategyDescription`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        if (!response.ok) {
          throw new Error('Failed to fetch strategy descriptions');
        }
        const data = await response.json();
        setStrategyDescriptions(data); // Set fetched data
      } catch (err) {
        setErrorMessage(err.message);
      }
    };

    fetchStrategyDescriptions();
  }, []);

  const handleSDCLinkClick = () => {
    setStrategyCode(sdCode || '');
    setStrategyDescriptionCode('');
    setErrorMessage('');
    setShowModal(true);  // Show modal when SDC Link is clicked
  };

  const handleSubmit = async () => {
    try {
      await linkStrategyToDescription(strategyCode, strategyDescriptionCode);
      alert('Strategy successfully linked to description!');
      setShowModal(false);  // Close the modal after successful submit
      window.location.reload();
    } catch (error) {
      setErrorMessage('Failed to link strategy to description');
    }
  };

  return (
    <div className='table-container' style={{ overflowX: 'auto', maxWidth: '100%' }}>
      {/* Strategy Highlights Table */}
      <table className="table" style={{ maxWidth: '200px', overflowX: 'auto', whiteSpace: 'nowrap' }}>
        <thead>
          <tr>
            <th>Strategy Description Code</th>
            <th>Winning Trades</th>
            <th>Losing Trades</th>
            <th>Total Trades</th>
            <th>Average Holding Period</th>
            <th>Video Link</th>
            <th>Average Stock Period</th>
            <th>Drawdown Period</th>
            <th>Status</th>
            <th>Strategy Description</th>
            <th>SDC Link</th>
          </tr>
        </thead>
        <tbody>
          {strategyHighlights ? (
            <tr>
              <td>{strategyHighlights.strategyDescriptionCode}</td>
              <td>{strategyHighlights.winningTrades}</td>
              <td>{strategyHighlights.losingTrades}</td>
              <td>{strategyHighlights.totalTrades}</td>
              <td>{strategyHighlights.averageHoldingPeriod}</td>
              <td style={{ textAlign: 'left', whiteSpace: 'nowrap' }}>
                {strategyHighlights.videoLink || 'N/A'}
              </td>
              <td>{strategyHighlights.averageStockPeriod}</td>
              <td>{strategyHighlights.drawDownPeriod}</td>
              <td>{strategyHighlights.status}</td>
              <td style={{ textAlign: 'left', whiteSpace: 'nowrap' }}>
                {strategyHighlights.strategyDescription}
              </td>
              <td
                style={{ cursor: 'pointer', color: 'blue' }}
                onClick={handleSDCLinkClick}  // Set state to show modal
              >
                SDC Link
              </td>
            </tr>
          ) : (
            <tr>
              <td colSpan="7">No strategy highlights available...</td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Conditional rendering for Modal */}
      {showModal && (
        <div className="modal show" style={{ display: 'block' }}>
          <div className="modal-dialog" style={{ maxHeight: '80%', margin: 'auto', marginTop: '100px' }}>
            <div className="modal-content" style={{ backgroundColor: '#e6e8ec' }}>
              <div className="modal-header">
                <h5 className="modal-title">Link Strategy to Description</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}  // Close modal on close button click
                ></button>
              </div>
              <div className="modal-body">
                <div>
                  <label>Strategy Code:</label>
                  <input
                    type="text"
                    value={strategyCode}
                    onChange={(e) => setStrategyCode(e.target.value)}
                    placeholder="Enter Strategy Code"
                    className="form-control"
                  />
                </div>
                <div>
                  <label>Strategy Description Code:</label>
                  <select
                    value={strategyDescriptionCode}
                    onChange={(e) => setStrategyDescriptionCode(e.target.value)}
                    className="form-control"
                  >
                    <option value="">Select Description Code</option>
                    {strategyDescriptions.map((desc) => (
                      <option key={desc.strategyDescriptionCode} value={desc.strategyDescriptionCode}>
                        {desc.strategyDescriptionCode}
                      </option>
                    ))}
                  </select>
                </div>
                {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}  // Close modal on button click
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}  // Handle form submission
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StrategyHighlightsTable;
